<template>
  <div>

    <!-- Modificatore della variabile Act-For per richiedere dati di altre aziende associate al referente aziendale -->
    <SwitcherAziende />

    <PageTagline
      :is_ref_azi_area="true"
      :elements="tagline_elem"
    />

    <!-- Card di contenimento della gestione dipendenti -->
    <b-overlay
      :show="overlay_show"
      rounded="sm"
    >
      <b-card
        title="Gestione Dipendenti"
        class="mr-1 ml-1"
      >

        <!-- Filtri e controlli della tabella -->
        <b-row class="mb-2">

          <!-- Elementi visualizzati per pagina -->
          <b-col
            cols="12"
            md="2"
          >
            <b-form-group
              id="group-page-size"
              label="Elementi visualizzati:"
              label-for="page-size"
            >
              <b-form-select
                id="page-size"
                v-model="page_size"
                :options="page_size_opt"
              />
            </b-form-group>
          </b-col>

          <!-- Filtro per stato dipendente -->
          <b-col
            cols="12"
            md="2"
          >
            <b-form-group
              id="group-stato-dipendente"
              label="Stato:"
              label-for="stato-dipendente"
            >
              <b-form-select
                id="stato-dipendente"
                v-model="filtro_stato"
                :options="filtro_stato_opt"
                @change="onStatoChange"
              />
            </b-form-group>
          </b-col>

          <!-- Ricerca nella tabella -->
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              id="group-filtro-tabella"
              label="Ricerca per termine:"
              label-for="filtro_tabella"
              description="Digita per ricercare all'interno dei dipendenti"
            >
              <b-form-input
                id="filtro_tabella"
                v-model="filter"
                placeholder="Cerca dipendente..."
              />
            </b-form-group>
          </b-col>

        </b-row>

        <b-row>
          <b-col>

            <!-- Tabella dipendenti -->
            <b-table
              responsive
              stacked="sm"
              :per-page="page_size"
              :current-page="page"
              :filter="filter"
              :items="dipendentiFiltrati"
              :fields="fields"
              :no-provider-filtering="true"
              :no-provider-sorting="true"
              show-empty
              @filtered="onFiltered"
            >
              <!-- Colonna azioni -->
              <template v-slot:cell(azioni)="data">
                <!-- Le operazioni sono disponibili solamente per i dipendenti attivi -->
                <div
                  v-if="data.item.is_cessato !== 1"
                  class="d-flex justify-content-center flex-wrap"
                >
                  <b-button
                    size="sm"
                    variant="primary"
                    class="m-1"
                    @click="resetPassword(data.item)"
                    :disabled="!!data.item.password_first_access"
                  >
                    <b-icon
                      icon="key"
                      class="mr-1"
                    />
                    Reset Password
                  </b-button>

                  <b-button
                    size="sm"
                    variant="primary"
                    class="m-1"
                    @click="resetCodice2FA(data.item)"
                    :disabled="!data.item.has_otp_secret"
                  >
                    <b-icon
                      icon="shield-lock"
                      class="mr-1"
                    />
                    Reset codice 2FA
                  </b-button>

                  <b-button
                    size="sm"
                    variant="primary"
                    class="m-1"
                    @click="inviaEmailPrimoAccesso(data.item)"
                    :disabled="!data.item.password_first_access"
                  >
                    <b-icon
                      icon="envelope"
                      class="mr-1"
                    />
                    Email primo accesso
                  </b-button>
                </div>
              </template>

              <!-- Nessun dipendente disponibile -->
              <template v-slot:empty>
                <p class="text-center">
                  <font-awesome-icon
                    icon="exclamation-circle"
                    size="lg"
                  />
                  Nessun dipendente disponibile
                </p>
              </template>

              <!-- Nessun risultato della ricerca -->
              <template v-slot:emptyfiltered>
                <p class="text-center">
                  <font-awesome-icon
                    icon="exclamation-circle"
                    size="lg"
                  />
                  Nessun dipendente trovato
                </p>
              </template>

            </b-table>

            <!-- Paginatore della tabella -->
            <b-pagination
              v-model="page"
              :per-page="page_size"
              :total-rows="items_tot"
              align="center"
            />

          </b-col>
        </b-row>

      </b-card>
    </b-overlay>

  </div>
</template>

<script>

import axios from "axios";
import PageTagline from "@/components/PageTagline";
import SwitcherAziende from "@/components/refaziendale/SwitcherAziende.vue";
import { generalLib } from "@/generalLib";
import { apiUrl } from "@/apiUrl";

export default {

  name: "GestioneDipendenti",

  components: {
    PageTagline,
    SwitcherAziende
  },

  data() {
    return {

      tagline_elem: [
        {
          text: "Gestione Dipendenti",
          link: "office-gestione-dipendenti"
        }
      ],

      // Mostra l'overlay durante caricamenti e operazioni.
      overlay_show: false,

      // Elenco completo dei dipendenti restituito dal backend.
      lista_utenti: [],

      // Numero di righe utilizzato dal paginatore.
      items_tot: 0,

      // Pagina corrente.
      page: 1,

      // Numero di elementi visualizzati per pagina.
      page_size: 50,

      page_size_opt: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
        { value: 500, text: "500" }
      ],

      /* Filtro per stato.
         All'apertura della pagina vengono visualizzati solamente i dipendenti attivi. */
      filtro_stato: "attivi",

      filtro_stato_opt: [
        {
          value: "attivi",
          text: "Attivi"
        },
        {
          value: "cessati",
          text: "Cessati"
        },
        {
          value: "tutti",
          text: "Vedi tutti"
        }
      ],

      // Ricerca testuale effettuata localmente dalla b-table.
      filter: null,

      // Definizione delle colonne della tabella.
      fields: [
        {
          key: "cognome",
          label: "Cognome",
          sortable: true,
          class: "text-center"
        },
        {
          key: "nome",
          label: "Nome",
          sortable: true,
          class: "text-center"
        },
        {
          key: "cod_fisc",
          label: "Codice Fiscale",
          sortable: true,
          class: "text-center"
        },
        {
          key: "azioni",
          label: "Azioni",
          sortable: false,
          class: "text-center"
        }
      ]
    };
  },

  computed: {

    /* Applica il filtro per stato prima di passare l'elenco dei dipendenti alla tabella. */
    dipendentiFiltrati() {

      if (this.filtro_stato === "attivi") {

        return this.lista_utenti.filter(
          utente => utente.is_cessato !== 1
        );
      }

      if (this.filtro_stato === "cessati") {

        return this.lista_utenti.filter(
          utente => utente.is_cessato === 1
        );
      }

      // Vedi tutti.
      return this.lista_utenti;
    }
  },

  created: function () {

    this.caricaDipendenti();
  },

  methods: {

    /* Recupera tutti i dipendenti dell'azienda.
       L'endpoint restituisce anche i dipendenti cessati;
       il filtro iniziale "Attivi" viene applicato successivamente dalla computed dipendentiFiltrati. */
    caricaDipendenti() {

      this.overlay_show = true;

      axios.get(
        apiUrl.welfareapi.anagrafica_utenti_by_azienda
      )
      .then((response) => {

        this.lista_utenti = response.data;

        /* I dipendenti cessati vengono evidenziati utilizzando la variante Bootstrap secondary. */
        for (let utente of this.lista_utenti) {

          if (utente.is_cessato === 1) {
            utente["_rowVariant"] = "secondary";
          }
        }

        /* L'endpoint restituisce già gli utenti ordinati, ma mantengo esplicitamente l'ordinamento alfabetico per cognome e nome. */
        this.lista_utenti.sort((a, b) => {

          const utenteA =
            `${a.cognome || ""} ${a.nome || ""}`.toLowerCase();

          const utenteB =
            `${b.cognome || ""} ${b.nome || ""}`.toLowerCase();

          return utenteA.localeCompare(
            utenteB,
            "it"
          );
        });

        // All'apertura il filtro è impostato su "Attivi".
        this.items_tot = this.dipendentiFiltrati.length;

        this.overlay_show = false;
      })
      .catch((error) => {

        this.overlay_show = false;

        generalLib.backend_error_message_box(
          this,
          error.response
            ? error.response.data
            : error
        );
      });
    },

    /* Aggiorna il numero totale delle righe e torna alla prima pagina quando cambia il filtro per stato. */
    onStatoChange() {

      this.page = 1;

      this.items_tot =
        this.dipendentiFiltrati.length;
    },

    /* Aggiorna il numero degli elementi del paginatore dopo l'applicazione della ricerca testuale. */
    onFiltered(filteredItems) {

      this.items_tot =
        filteredItems.length;

      this.page = 1;
    },

    /* Richiede conferma prima di effettuare il reset della password. */
    resetPassword(utente) {

      const nomeCompleto =
        `${utente.nome || ""} ${utente.cognome || ""}`.trim();

      this.$bvModal.msgBoxConfirm(
        "Confermi il reset della password di " +
        nomeCompleto +
        "? La password verrà reimpostata al codice fiscale " +
        "e dovrà essere modificata al primo accesso.",
        {
          title: "Reset Password",
          size: "sm",
          okVariant: "danger",
          okTitle: "Conferma",
          cancelTitle: "Annulla",
          cancelVariant: "secondary",
          hideHeaderClose: false,
          centered: true
        }
      )
      .then((confermato) => {

        if (!confermato) {
          return;
        }

        this.eseguiResetPassword(
          utente
        );
      });
    },

    /* Invia al backend solamente l'UID del dipendente.
       Azienda, stato del dipendente e codice fiscale vengono verificati nuovamente lato backend. */
    eseguiResetPassword(utente) {

      this.overlay_show = true;

      axios.post(

        apiUrl.welfareapi.reset_password_dipendente,
        {
          uid: utente.uid
        }
      )
      .then(() => {

        this.overlay_show = false;

        this.$bvModal.msgBoxOk(
          "Password resettata correttamente. " +
          "Al prossimo accesso il dipendente dovrà modificarla.",
          {
            title: "Reset completato",
            okTitle: "OK",
            centered: true
          }
        );
        this.caricaDipendenti();
      })
      .catch((error) => {

        this.overlay_show = false;

        generalLib.backend_error_message_box(
          this,
          error.response
            ? error.response.data
            : error
        );
      });
    },
    /* Richiede conferma prima di effettuare il reset del codice 2FA. */
    resetCodice2FA(utente) {
      const nomeCompleto =
        `${utente.nome || ""} ${utente.cognome || ""}`.trim();

      this.$bvModal.msgBoxConfirm(
        "Confermi il reset del codice 2FA di " +
        nomeCompleto +
        "?",
        {
          title: "Reset codice 2FA",
          size: "sm",
          okVariant: "danger",
          okTitle: "Conferma",
          cancelTitle: "Annulla",
          cancelVariant: "secondary",
          hideHeaderClose: false,
          centered: true
        }
      )
      .then((confermato) => {
        if (!confermato) {
          return;
        }

        this.eseguiResetCodice2FA(
          utente
        );
      });
    },
    /* Invia al backend solamente l'UID del dipendente.
       Azienda e stato del dipendente vengono verificati nuovamente lato backend. */
    eseguiResetCodice2FA(utente) {
      this.overlay_show = true;

      axios.post(
        apiUrl.welfareapi.reset_otp_dipendente,
        {
          uid: utente.uid
        }
      )
      .then(() => {
        this.overlay_show = false;

        this.$bvModal.msgBoxOk(
          "Codice 2FA resettato correttamente.",
          {
            title: "Reset 2FA completato",
            okTitle: "OK",
            centered: true
          }
        )
        .then((confermato) => {
          if (!confermato) {
            return;
          }

          this.caricaDipendenti();
        });
      })
      .catch((error) => {
        this.overlay_show = false;

        generalLib.backend_error_message_box(
          this,
          error.response
            ? error.response.data
            : error
        );
      });
    },
    /* Richiede conferma prima di inviare l'email di primo accesso. */
    inviaEmailPrimoAccesso(utente) {
      const nomeCompleto =
        `${utente.nome || ""} ${utente.cognome || ""}`.trim();

      this.$bvModal.msgBoxConfirm(
        "Confermi l'invio dell'email di primo accesso a " +
        nomeCompleto +
        "?",
        {
          title: "Email primo accesso",
          size: "sm",
          okVariant: "primary",
          okTitle: "Invia",
          cancelTitle: "Annulla",
          cancelVariant: "secondary",
          hideHeaderClose: false,
          centered: true
        }
      )
      .then((confermato) => {
        if (!confermato) {
          return;
        }

        this.eseguiEmailPrimoAccesso(
          utente
        );
      });
    },

    /* Invia al backend solamente l'UID del dipendente.
       Azienda e stato del dipendente vengono verificati nuovamente lato backend. */
    eseguiEmailPrimoAccesso(utente) {
      this.overlay_show = true;

      axios.post(
        apiUrl.welfareapi.email_primo_accesso_dipendente,
        {
          uid: utente.uid
        }
      )
      .then(() => {
        this.overlay_show = false;

        this.$bvModal.msgBoxOk(
          "Email di primo accesso inviata correttamente.",
          {
            title: "Email inviata",
            okTitle: "OK",
            centered: true
          }
        );
      })
      .catch((error) => {
        this.overlay_show = false;

        generalLib.backend_error_message_box(
          this,
          error.response
            ? error.response.data
            : error
        );
      });
    }

  }
};

</script>

<style scoped>

</style>